// extracted by mini-css-extract-plugin
export var actionText = "_sf-4";
export var container = "_sf-0";
export var leftSection = "_sf-1";
export var rightSection = "_sf-2";
export var settingsButton = "_sf-6";
export var settingsIcon = "_sf-7";
export var shortcut = "_sf-5";
export var shortcutGroup = "_sf-3";